export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5048.9871732c.jpg";